import { createContext, use } from 'react';

/**
 * The application's one way of saying something in passing.
 *
 * Notifications are for things that happened, not for things a person must act
 * on: "sessão encerrada", "cadastro salvo". Anything that needs a decision
 * belongs on the page, where it cannot be missed or dismissed by a timer.
 *
 * Nothing personal goes in one. A toast is rendered outside the page's own
 * region, can be screenshotted by whatever is recording the screen, and is read
 * aloud by assistive technology in whatever room the person is in.
 */
export type NotificationTone = 'info' | 'success' | 'warning' | 'error';

export interface Notification {
  readonly id: string;
  readonly tone: NotificationTone;
  readonly message: string;
}

export interface NotificationApi {
  notify: (tone: NotificationTone, message: string) => void;
  dismiss: (id: string) => void;
}

export const NotificationContext = createContext<NotificationApi | null>(null);

export function useNotifications(): NotificationApi {
  const api = use(NotificationContext);
  if (api === null) {
    throw new Error('useNotifications precisa de <NotificationProvider> acima na árvore.');
  }
  return api;
}
